import { useEntitlementsUsage } from '@/hooks/account/useBilling';

/**
 * The plan's parsing limits, shown before anything is uploaded so a long file
 * isn't a surprise afterwards: pages per file and pages left this month.
 * Empty while usage loads (the server enforces the limits either way).
 */
export function useParseLimits() {
  const { data } = useEntitlementsUsage();
  const perFile = data?.pages_per_source ?? null;
  const left = data?.pages_parsed?.remaining ?? null;
  const parts: string[] = [];
  if (perFile !== null)
    parts.push(`up to ${perFile.toLocaleString()} pages a file`);
  if (left !== null)
    parts.push(`${left.toLocaleString()} pages left this month`);
  return {
    sourcesPerLesson: data?.sources_per_lesson ?? null,
    pagesPerFile: perFile,
    pagesLeft: left,
    /** " · up to 50 pages a file · 80 pages left this month", or "". */
    note: parts.length ? ` · ${parts.join(' · ')}` : '',
  };
}
